import { __makeTemplateObject } from "tslib";
import { css } from 'styled-components';
/* because we cannot for now ASSUME that everybody has box-sizing border-box,
 * we should use this on the root css of our components.
 */
export var boxSizingBorderBox = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  box-sizing: border-box;\n  * {\n    box-sizing: border-box;\n  }\n"], ["\n  box-sizing: border-box;\n  * {\n    box-sizing: border-box;\n  }\n"])));
var templateObject_1;
//# sourceMappingURL=extends.js.map